import React, { useState } from "react";
import { Container, Row, Col, Button} from "react-bootstrap";
import { getUrlGovBr } from "../../services/oAuth";
import Identifica from "./../../tools/Identifica";

import "./styles.css";

export default function Login({ history }) {

  const [modalShow, setModalShow] = useState(false);
  
  function handleSistema(){
    setModalShow(true);
  }
  function handleGovbr(){
    window.location=getUrlGovBr();
  }
  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <div className="voltar">
              <a href="/">voltar</a>
            </div>
          </Col>
        </Row>
        <form id="formContribuinte">
          <div className="quadro Mostrar">
            <Identifica 
              id="Identifica"
              show={modalShow} 
              onHide={() => setModalShow(false)} />
            <Row>
              <Col sm="12" className="centralizar">
                <h3>Identificação de Participante</h3>
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <div className="quadro Mostrar centralizar">
                  <h4>IDENTIFICAÇÃO PELO SISTEMA</h4>
                </div>
                <div className="quadro Mostrar">
                  <p>
                    Para usuários já cadastrados no sistema ou internos da ANA, é possível utilizar a identificação no próprio sistema. 
                    Caso contrario, utilize a opção "Entrar com gov.br" ao lado!
                    <br />
                  </p>
                  <p className="centralizar">
                    <Button variant="success" onClick={handleSistema}>Entrar pelo sistema</Button>
                  </p>
                  <br /><br />
                </div>
              </Col>
              <Col sm="6">
                <div className="quadro Mostrar centralizar">
                  <h4>ACESSO GOVBR</h4>
                </div>
                <div className="quadro Mostrar">
                  <p>
                    O gov.br é um serviço online de identificação e autenticação digital do
                    cidadão em um único meio para acesso aos diversos serviços públicos digitais. 
                    <br />
                  </p>
                  <p className="centralizar">
                    <button className="br-button sign-in primary" 
                      type="button"
                      onClick={handleGovbr}>
                      Entrar com&nbsp;
                      <span className="text-black">gov.br</span>
                    </button>
                  </p>
                  <p  className="centralizar">
                    <a href="https://www.gov.br/governodigital/pt-br/conta-gov-br/conta-gov-br/">
                        Saiba mais sobre GOV.BR
                    </a>
                  </p>
                </div>
              </Col> 
            </Row>

            <p className="centralizar">
                    <a href="/PoliticaPrivacidade">Política de Privacidade</a>
            </p>
          </div>
        </form>
      </Container>
    </>
  );
}